exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".map-uv_num[data-v-78898635]{width:2rem}.map-uv_p[data-v-78898635]{height:0.2rem;background:#90c328;border-radius:0.02667rem}", ""]);

// exports
